import { ValueOf } from '../../../../../../shared/type/util.type.ts';
import { ProductHelperFactory } from '@services/MarppleShop/features/ProductHelper/strategies';
import { FundingListResponse } from '@services/MarppleShop/features/Funding';
import { every, pipe } from '@fxts/core';

export const FundingStatus = {
  COMING_SOON: 'COMING_SOON',
  ING: 'ING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  BREAKTHROUGH: 'BREAKTHROUGH',
} as const;

export type FundingStatuses = ValueOf<typeof FundingStatus>;

export class FundingHelper {
  private static productHelper = ProductHelperFactory.createMpsV1();

  static percentage(data: { total_amount: number; goal_amount: number }): number {
    const { total_amount, goal_amount } = data;

    const percentage = (total_amount / goal_amount) * 100;

    return Math.trunc(percentage);
  }

  static status(data: {
    total_amount: number;
    goal_amount: number;
    sell_start_at?: Date;
    sell_end_at?: Date;
    quantity: number;
    out_of_stock: boolean;
    order_count: number;
  }): FundingStatuses {
    const {
      total_amount = 0,
      goal_amount,
      sell_start_at = null,
      sell_end_at = null,
      order_count,
      out_of_stock,
      quantity,
    } = data;

    if (this.productHelper.isBeforeSale(sell_start_at)) return FundingStatus.COMING_SOON;

    if (this.productHelper.isEndedSale({ sell_end_at }) && total_amount < goal_amount)
      return FundingStatus.FAILED;

    if (
      this.productHelper.isSoldOut({ out_of_stock, quantity, order_count, sell_end_at }) &&
      total_amount < goal_amount
    )
      return FundingStatus.FAILED;

    if (this.productHelper.isEndedSale({ sell_end_at }) && total_amount >= goal_amount)
      return FundingStatus.SUCCESS;

    if (
      this.productHelper.isSoldOut({ out_of_stock, quantity, order_count, sell_end_at }) &&
      total_amount >= goal_amount
    )
      return FundingStatus.SUCCESS;

    if (total_amount >= goal_amount) return FundingStatus.BREAKTHROUGH;
    return FundingStatus.ING;
  }

  static isAllEndedFunding(fundings: FundingListResponse['data']): boolean {
    return pipe(
      fundings,
      every((funding) => {
        const status = FundingHelper.status({
          goal_amount: funding.goalAmount,
          total_amount: funding.totalAmount,
          sell_start_at: funding.sellStartAt,
          sell_end_at: funding.sellEndAt,
          order_count: funding.orderCount || 0,
          quantity: funding.quantity || 0,
          out_of_stock: Boolean(funding.outOfStock),
        });

        return status === FundingStatus.SUCCESS || status === FundingStatus.FAILED;
      }),
    );
  }
}
